import http from './axios';

// const prefix = "http://test-plugin-ft.10jqka.com.cn/plugingwapi/api"
const prefix = "/plugingwapi/api";

export function getList(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/list',
    params
  });
}
export function getRelated(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/related/list',
    params
  });
}
export function getDetail(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/detail',
    params
  });
}
export function collect(params) {
  return http.post({
    url: prefix + '/news_plugin_service/imgdata/collect',
    params
  });
}
export function getCollect(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/collect/list',
    params
  });
}
export function getHistoryList(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/history/list',
    params
  });
}
export function clearHistory(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/history/remove',
    params
  });
}
export function saveHistory(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/history/save',
    params
  });
}
export function getTypeList(params) {
  return http.get({
    url: prefix + '/news_plugin_service/imgdata/typeList',
    params
  });
}
export function download(params) {
  return http.getBlob({
    url: prefix + '/news_plugin_service/imgdata/download',
    params
  });
}
export function getAuth(params) {
  return http.get({
    url: prefix +  '/news_plugin_service/aigc/checkSdPermission',
    params
  });
}